// Both limits mirror checklistDescriptionMaxText and MaxHTML in eca-backend db/checklist_manip.go.
export const DESCRIPTION_LIMIT = 300;
export const DESCRIPTION_HTML_LIMIT = 2000;

const visibleText = html =>
	new DOMParser().parseFromString(html ?? '', 'text/html').body.textContent ?? '';

export const descriptionLength = html => {
	if (!html) return 0;
	return [...visibleText(html).trim()].length;
};

export const isDescriptionTooBig = html =>
	descriptionLength(html) > DESCRIPTION_LIMIT ||
	new TextEncoder().encode(html ?? '').length > DESCRIPTION_HTML_LIMIT;

export const normalizeDescription = html => (descriptionLength(html) === 0 ? '' : html);

const ALLOWED_LINK = /^(https?:|mailto:)/i;
// Go's url.Parse rejects a "%" that doesn't start an escape, so the backend would refuse the save.
const STRAY_PERCENT = /%(?![0-9a-f]{2})/gi;

export const isAllowedLinkUrl = input => {
	const url = String(input ?? '').trim();
	return ALLOWED_LINK.test(url) && !url.match(STRAY_PERCENT);
};

// A prefix without a dot before ":" is a scheme (tel:, ftp:); "example.com:8080" is a host and port.
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const hasScheme = url => HAS_SCHEME.test(url) && !/^[^:]*\.[^:]*:\d/.test(url);

// "help@acme.com" with no scheme or path is an email address, not https://help@acme.com.
const BARE_EMAIL = /^[^\s@/:]+@[^\s@/:]+\.[^\s@/:]+$/;

export const normalizeLinkUrl = input => {
	const url = String(input ?? '')
		.trim()
		.replace(STRAY_PERCENT, '%25');
	if (!url || /\s/.test(url) || url.startsWith('//')) return null;
	if (BARE_EMAIL.test(url)) return `mailto:${url}`;
	const normalized = hasScheme(url) ? url : `https://${url}`;
	return isAllowedLinkUrl(normalized) ? normalized : null;
};
